import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import GlobalStyle from './styles/GlobalStyle.jsx'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

import Home from './pages/Home.jsx'
import Dashboard from './pages/Dashboard'
import PrivateProfile from './pages/PrivateProfile'
import Product from './pages/Product'
import NewProduct from './pages/NewProduct'
import PublicProfile from './pages/PublicProfile'
import Chat from './pages/Chat'
// import Miscellaneous from './pages/Miscellaneous'
import Error from './pages/Error'

const root = ReactDOM.createRoot(document.getElementById('root'))

const queryClient = new QueryClient()

root.render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <Router>
                <GlobalStyle />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/Dashboard" element={<Dashboard />} />
                    <Route
                        path="/PrivateProfile"
                        element={<PrivateProfile />}
                    />
                    <Route path="/NewProduct" element={<NewProduct />} />
                    <Route path="/Product/:thingNumber" element={<Product />} />
                    <Route
                        path="/PublicProfile/:userNumber"
                        element={<PublicProfile />}
                    />
                    <Route path="/Chat" element={<Chat />} />
                    {/* <Route path="/Miscellaneous" element={<Miscellaneous />} /> */}

                    <Route path="*" element={<Error />} />
                </Routes>
            </Router>
            <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
    </React.StrictMode>
)
